import React from 'react';
export const ModalContext = /*#__PURE__*/React.createContext({});
const ModalContextProvider = ModalContext.Provider;
export { ModalContextProvider };